<script>
    import { inputField } from '../state/store';
</script>

<input bind:value={$inputField}/>